module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("XCircle_COM")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "100",
      "src": "http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Fx-circle"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("演示")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "377px",
      "height": "667px",
      "display": "inline-block",
      "border": "1px dashed #ececec",
      "border-radius": "5px",
      "overflow": "hidden"
    }
  }, [_c('iframe', {
    attrs: {
      "src": "https://vux.li/demos/v2/#/component/x-circle",
      "width": "375",
      "height": "667",
      "border": "0",
      "frameborder": "0"
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v("demo 代码")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h4', [_vm._v("Github Issue")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticStyle: {
      "font-size": "12px",
      "color": "#888"
    },
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-circle",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接：https://vux.li/demos/v2/#/component/x-circle")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"vux-circle-demo\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'width:150px;height:150px;'")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-circle")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":percent")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"percent1\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":stroke-width")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"10\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("stroke-color")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"#04BE02\"")]), _vm._v(">")]), _vm._v("\n        "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _c('span', [_vm._v("{{")]), _vm._v("percent1"), _c('span', [_vm._v("}}")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-circle")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'width:100px;height:100px;'")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-circle")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":percent")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"percent1\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":stroke-width")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"5\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("stroke-color")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"#04BE02\"")]), _vm._v(">")]), _vm._v("\n        "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _c('span', [_vm._v("{{")]), _vm._v("percent1"), _c('span', [_vm._v("}}")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-circle")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'width:50px;height:50px;'")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-circle")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":percent")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"percent1\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":stroke-width")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"5\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("stroke-color")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"#04BE02\"")]), _vm._v(">")]), _vm._v("\n        "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _c('span', [_vm._v("{{")]), _vm._v("percent1"), _c('span', [_vm._v("}}")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-circle")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"width:180px;\"")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("range")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"percent1\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":min")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"0\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":max")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"100\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("range")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'width:100px;height:100px;'")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-circle")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":percent")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"100\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":stroke-width")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"3\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("stroke-color")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"#04BE02\"")]), _vm._v(">")]), _vm._v("\n        "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"success\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-circle")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'width:100px;height:100px;'")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-circle")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":percent")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"percent2\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":stroke-width")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"6\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":trail-width")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"6\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":stroke-color")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"strokeColor2\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("trail-color")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"#ececec\"")]), _vm._v(">")]), _vm._v("\n        "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"{color: strokeColor2}\"")]), _vm._v(">")]), _c('span', [_vm._v("{{")]), _vm._v("percent2"), _c('span', [_vm._v("}}")]), _vm._v("%"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-circle")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _c('span', {
    staticClass: "javascript"
  }, [_vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XCircle, Range, Icon } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  ready () {\n    setInterval("), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".update2, "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("2000")]), _vm._v(")\n  },\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("components")]), _vm._v(": {\n    XCircle,\n    Range,\n    Icon\n  },\n  data () {\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" {\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("percent1")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("10")]), _vm._v(",\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("percent2")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("30")]), _vm._v(",\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("strokeColor2")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'#3FC7FA'")]), _vm._v("\n    }\n  },\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("methods")]), _vm._v(": {\n    update2 () {\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" colorMap = ["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'#3FC7FA'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'#85D262'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'#FE8C6A'")]), _vm._v("]\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".percent2 = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("parseInt")]), _vm._v("("), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("Math")]), _vm._v(".random() * "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("100")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("10")]), _vm._v(")\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".strokeColor2 = colorMap["), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("parseInt")]), _vm._v("("), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("Math")]), _vm._v(".random() * "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("3")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("10")]), _vm._v(")]\n    }\n  }\n}\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("scoped")]), _vm._v(">")]), _c('span', {
    staticClass: "css"
  }, [_vm._v("\n"), _c('span', {
    staticClass: "hljs-selector-class"
  }, [_vm._v(".vux-circle-demo")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("text-align")]), _vm._v(": center;\n}\n"), _c('span', {
    staticClass: "hljs-selector-class"
  }, [_vm._v(".vux-circle-demo")]), _vm._v(" > "), _c('span', {
    staticClass: "hljs-selector-tag"
  }, [_vm._v("div")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("margin")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v(" auto;\n}\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(">")]), _vm._v("\n\n")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f4ff5c1a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-f4ff5c1a"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/x-circle-421.vue
// module id = 3050
// module chunks = 178